import { render, staticRenderFns } from "./checkbox-button.vue?vue&type=template&id=4a77e2d0&"
import script from "./checkbox-button.vue?vue&type=script&lang=js&"
export * from "./checkbox-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a77e2d0')) {
      api.createRecord('4a77e2d0', component.options)
    } else {
      api.reload('4a77e2d0', component.options)
    }
    module.hot.accept("./checkbox-button.vue?vue&type=template&id=4a77e2d0&", function () {
      api.rerender('4a77e2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/checkbox-button/checkbox-button.vue"
export default component.exports